import type { DeleteStoredDocumentGraphqlInput } from '~/types/graphql-backend-types/gql-types'
import { useMutation, useQueryClient } from '@tanstack/vue-query'
import gql from 'graphql-tag'

export function useDeleteStoredDocument() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['delete-stored-document'],
    mutationFn: (input: DeleteStoredDocumentGraphqlInput) => deleteStoredDocument(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['documents'] })
    },
  })
}

async function deleteStoredDocument(input: DeleteStoredDocumentGraphqlInput) {
  const { mutate } = useGqlMikro()

  const { data, errors } = await mutate({
    mutation: DELETE_STORED_DOCUMENT,
    variables: { input },
  })

  if (errors && errors.length > 0) {
    throw errors
  }

  return data?.deleteStoredDocument
}

export const DELETE_STORED_DOCUMENT = gql`
mutation DeleteStoredDocument($input: DeleteStoredDocumentGraphqlInput!) {
  deleteStoredDocument(input: $input)
}
`
